import { AdminExtra } from '../model/adminExtra';
import { ProductBuilder } from './product-builder';
import { Location } from '../model/location';
import { ImageGalleryBuilder } from "./image-gallery-builder";
export class AdminExtraBuilder {
    static buildLocationObject(obj) {
        let locationObj = new Location(obj.lat, obj.lng);
        return locationObj;
    }
    static buildData(check) {
        let data = {};
        for (let info in check) {
            if (check[info] instanceof Array) {
                data[info] = _.map(check[info], (_check) => {
                    return ProductBuilder.buildInfoSection(_check);
                });
            }
            else {
                data[info] = this.buildLocationObject(check[info]);
            }
        }
        return data;
    }
    static buildAdminExtra(data) {
        const adminExtra = new AdminExtra();
        adminExtra.id = data.id;
        adminExtra.is_active = data.is_active;
        adminExtra.is_public = data.is_public;
        adminExtra.id_product = data.id_product;
        adminExtra.id_rsys = data.id_rsys;
        adminExtra.id_key_zone = data.id_key_zone;
        adminExtra.name_es = data.name_es;
        adminExtra.name_ca = data.name_ca;
        adminExtra.name_fr = data.name_fr;
        adminExtra.name_en = data.name_en;
        adminExtra.keys_needed = +data.keys_needed ? true : false;
        adminExtra.send_desinfection_seal = +data.send_desinfection_seal ? true : false;
        adminExtra.type = data.type;
        adminExtra.icon = data.icon;
        adminExtra.image_gallery = data.image_gallery ? ImageGalleryBuilder.buildImageGallery(data.image_gallery) : null;
        adminExtra.description_es = data.description_es;
        adminExtra.description_ca = data.description_ca;
        adminExtra.description_fr = data.description_fr;
        adminExtra.description_en = data.description_en;
        adminExtra.long_description_es = data.long_description_es;
        adminExtra.long_description_ca = data.long_description_ca;
        adminExtra.long_description_fr = data.long_description_fr;
        adminExtra.long_description_en = data.long_description_en;
        adminExtra.check_in_es = this.buildData(data.check_in_es);
        adminExtra.check_in_ca = this.buildData(data.check_in_ca);
        adminExtra.check_in_fr = this.buildData(data.check_in_fr);
        adminExtra.check_in_en = this.buildData(data.check_in_en);
        adminExtra.check_out_es = this.buildData(data.check_out_es);
        adminExtra.check_out_ca = this.buildData(data.check_out_ca);
        adminExtra.check_out_fr = this.buildData(data.check_out_fr);
        adminExtra.check_out_en = this.buildData(data.check_out_en);
        adminExtra.price_calculation = data.price_calculation;
        adminExtra.wash_id = data.wash_id;
        adminExtra.id_product_option = data.id_product_option;
        adminExtra.t1_pvp_extra = data.t1_pvp_extra;
        adminExtra.t2_pvp_extra = data.t2_pvp_extra;
        adminExtra.t3_pvp_extra = data.t3_pvp_extra;
        adminExtra.t4_pvp_extra = data.t4_pvp_extra;
        adminExtra.t5_pvp_extra = data.t5_pvp_extra;
        adminExtra.service_type = data.service_type;
        return adminExtra;
    }
}
//# sourceMappingURL=adminExtra-builder.js.map